<template>
  <div class="card shadow-sm mb-4">
    <div class="card-body text-center text-md-left">
      <div class="row">
        <div class="col-md-6 col-lg-3 mb-1">
          <label for="relatorio" class="small font-weight-bold mb-0">Selecione o Relatório</label>
          <select id="relatorio" class="form-control" v-model="pesquisa.relatorio">
            <option value="1">Resumo Diário</option>
            <option value="5">Resumo Mensal</option>
            <option value="2">Vendas no Período</option>
            <option value="3">Vendas por produto</option>
            <option value="4">Estoque de produtos</option>
            <option value="6">Taxas de Serviços</option>
            <option value="7">Saldo dos Caixas</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-3 mb-1" v-if="['1','2','7'].includes(pesquisa.relatorio)">
          <label class="small font-weight-bold mb-0" for="data_inicio">
            {{ pesquisa.relatorio === '1' ? 'Dia' : 'De' }}
          </label>
          <input class="form-control" id="data_inicio" type="date" v-model="pesquisa.dt_inicio">
        </div>
        <div class="col-md-6 col-lg-3 mb-1" v-if="['2','7'].includes(pesquisa.relatorio)">
          <label class="small font-weight-bold mb-0" for="data_fim">Até</label>
          <input class="form-control" id="data_fim" type="date" v-model="pesquisa.dt_fim">
        </div>
        <div class="col-md-6 col-lg-3 mb-1" v-if="pesquisa.relatorio === '5'">
          <label class="small font-weight-bold mb-0">Mês</label>
          <select class="form-control" v-model="pesquisa.mes">
            <option value="1">Janeiro</option>
            <option value="2">Fevereiro</option>
            <option value="3">Março</option>
            <option value="4">Abril</option>
            <option value="5">Maio</option>
            <option value="6">Junho</option>
            <option value="7">Julho</option>
            <option value="8">Agosto</option>
            <option value="9">Setembro</option>
            <option value="10">Outubro</option>
            <option value="11">Novembro</option>
            <option value="12">Dezembro</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-3 mb-1" v-if="pesquisa.relatorio === '5'">
          <label class="small font-weight-bold mb-0">Ano</label>
          <select class="form-control" v-model="pesquisa.ano">
            <option value="2019">2019</option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
          </select>
        </div>
        <div class="col-md-6 col-lg-3 mb-1 ml-auto">
          <label>&nbsp;</label>
          <button class="btn btn-secondary btn-block" @click="buscarRelatorioVendas()">Gerar Relatório</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExportarRelatorio",
  data() {
    return {
      token: localStorage.getItem('key'),
      load: true,
      pesquisa: {
        relatorio: '1',
        periodo: '1',
        mes: '',
        ano: '',
        dt_inicio: new Date().toDateInputValue(),
        dt_fim: new Date().toDateInputValue()
      }
    }
  },

  methods: {
    buscarRelatorioVendas() {
      let urlPortal = null;
      let url = this.base_server + 'api/';

      switch (this.pesquisa.relatorio) {
        case '1':
        case '5':
          url += 'comandas/vendas-formas-pagamento/';
          break;
        case '2':
          url += 'comandas/vendas-diarias/';
          break;
        case '3':
          urlPortal = 'relatorios/produtos';
          break;
        case '4':
          urlPortal = 'cardapio/estoque';
          break;
        case '6':
          urlPortal = 'relatorios/vendedores';
          break;
        case '7':
          url += 'caixas/saldo-caixa/';
          break;
      }

      if (urlPortal) {
        window.open(this.$helpers.getUrlPortal() + urlPortal);
        return;
      }

      url += this.token;

      if (this.pesquisa.relatorio === '5') {
        url += `?mes=${this.pesquisa.mes}&ano=${this.pesquisa.ano}`;

      } else {
        this.pesquisa.dt_fim = this.pesquisa.relatorio === '1' ? this.pesquisa.dt_inicio : this.pesquisa.dt_fim;
        url += '?dt_inicio=' + this.pesquisa.dt_inicio +'&dt_fim=' + this.pesquisa.dt_fim;
      }

      this.$helpers.openArquivo(this, url, 'pdf');
    }
  },

  mounted() {
    const date = new Date();
    this.pesquisa.ano = date.getFullYear();
    this.pesquisa.mes = date.getMonth() + 1;
  }
}
</script>

<style scoped>

</style>